// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PasswordRequirements when password contains 3 characters in a row renders the component 1`] = `
.c0 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

<div>
  <div
    style="margin: 5px 0px 20px;"
  >
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least 8 characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Not contain more than two identical characters in a row
    </div>
  </div>
</div>
`;

exports[`PasswordRequirements when password contains 8 chars renders the component 1`] = `
.c0 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

<div>
  <div
    style="margin: 5px 0px 20px;"
  >
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least 8 characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Not contain more than two identical characters in a row
    </div>
  </div>
</div>
`;

exports[`PasswordRequirements when password contains upper, lower, digits and special chars renders the component 1`] = `
.c0 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

<div>
  <div
    style="margin: 5px 0px 20px;"
  >
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least 8 characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Not contain more than two identical characters in a row
    </div>
  </div>
</div>
`;

exports[`PasswordRequirements when password is empty renders the component 1`] = `
.c0 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

<div>
  <div
    style="margin: 5px 0px 20px;"
  >
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least 8 characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#C5CAD3"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          d="M10.7 6.7L9.4 8l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 9.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 8 5.3 6.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 6.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
          fill="currentColor"
        />
        <path
          clip-rule="evenodd"
          d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Not contain more than two identical characters in a row
    </div>
  </div>
</div>
`;

exports[`PasswordRequirements when password is valid renders the component 1`] = `
.c0 {
  font-size: 12px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #737482;
  line-height: 140%;
  margin-bottom: 2px;
}

<div>
  <div
    style="margin: 5px 0px 20px;"
  >
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least 8 characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Contain at least three of the following: uppercase letters, lowercase letters, digits, and special characters
    </div>
    <div
      class="c0"
    >
      <svg
        color="#47B052"
        fill="none"
        focusable="false"
        height="12"
        style="margin: 2px 5px 0px 0px; flex-shrink: 0;"
        viewBox="0 0 16 16"
        width="12"
      >
        <path
          clip-rule="evenodd"
          d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-5.707-2.707L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
      Not contain more than two identical characters in a row
    </div>
  </div>
</div>
`;
